import store from '../redux/store'

import { showLoader, hideLoader } from '../redux/loader/actions'

export const setLoader = (visibility: boolean): void => {
  if (visibility) {
    store.dispatch(showLoader())
  } else {
    store.dispatch(hideLoader())
  }
}
